module.exports = __webpack_public_path__ + "static/media/activeLoanBorrower.005ac2d9.svg";